export default "__VITE_ASSET__DAOqhvw9__"